export const getColorByHttpMethod = (method) => {
  switch (method) {
    case 'GET':
      return 'blue'
    case 'POST':
      return 'green'
    case 'PUT':
      return 'yellow'
    case 'PATCH':
      return 'orange'
    case 'DELETE':
      return 'red'
    case 'HEAD':
      return 'grey'
    case 'OPTIONS':
      return 'olive'
  }
}